// extracted by mini-css-extract-plugin
export default {"screen":"LoadingScreen_screen__n6iRs","content":"LoadingScreen_content__0NNCx","spinner":"LoadingScreen_spinner__cDciY","text":"LoadingScreen_text__qXIAT"};